import React, { useRef } from 'react';
const Client = require('gmi-api').Client

export default (user) => {
  const client = useRef(new Client(user)).current
  client.setUser(user)
  return client
}

